export default {
	'search-item-id-or-name': 'بحث عن رقم أو اسم الحساب',
	'show-main-item': 'إظهار المواد الرئيسية',
	'items-with-quantities-only': 'المواد ذات الكميات المتوفرة',
	'store-items': 'المستودع',
	'inventory-matching': 'مطابقة جرد'
}